import Vue from 'vue'
import moment from 'moment'
import VueLogger from '@/utils/common/logger'
import Vconsole from 'vconsole'
import { appUser, pageArgs } from '@/utils'
// import { Toast } from 'mint-ui';
export const integralName = '积分'
// 默认用户头像
export const defaultUserIcon = 'https://img-cdn1.ylyk.com/audio-1599811120-64k44100.png'
// 默认班主任图片
// export const defaultAdviserImg = 'https://img-cdn1.ylyk.com/image/1617262217208_m1617262207993_s90725.jpg'
export const defaultAdviserImg = ''
// 默认商品图片
export const defaultGoodsIcon = 'https://img-ylsn.ylyk.com/server/image/course/2025_10_09_1760004252599.png'

// 内部用户放开调试器
const innerUserIds = [21]
export function isInnerUser() {
  return innerUserIds.indexOf(appUser.userId) >= 0
}

function useVconsoleToInnerUser() {
  // 调试工具
  const showConsole = pageArgs.args().showConsole != null
  const bool = window.location.href.indexOf('test') > 0 // 测试环境全部放开
  if (showConsole || isInnerUser() || bool) {
    // if (showConsole || isInnerUser()) {
    const vConsole = new Vconsole()
    Vue.use(vConsole)
  }
}

function setPlugin() {
  Vue.prototype.$moment = moment
}

export function useConfig() {
  setPlugin() // 设置插件
  useVconsoleToInnerUser() // 启动控制台
  Vue.use(VueLogger) // 日志
}

/**
 * 资源配置信息
 */
export default {
  defaultAdviserImg,
  defaultGoodsIcon,
  showConsole: false
}
